import { Skeleton, Button } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { Row, Col } from "antd";
import { useLoading } from "infra/helpers/alerta";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import { MeetingContainer } from "./styles";
import useAssembleia from "core/features/assembleia/hooks/useAssembleia";
import { MdHowToVote, MdPlayCircle } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import colors from "core/resources/theme/colors";

interface VideoConferenciaProps {
  idAssembleia: string;
}

function VideoConferencia({ idAssembleia }: VideoConferenciaProps) {
  const { data, isLoading: isLoadingAssembleia } = useAssembleia(idAssembleia);

  useLoading(isLoadingAssembleia);

  return (
    <>
      <Box mb="16px">
        <Row gutter={16}>
          <Col sm={7}>
            <Card1Horizontal
              bg={colors.blue100}
              color={colors.blue}
              description="Participantes"
              icon={<FaUsers fontSize="24px" color={colors.purple} />}
              title={"0"}
              loading={false}
            />
          </Col>
          <Col sm={7}>
            <Card1Horizontal
              bg={colors.blue100}
              color={colors.blue}
              description="Votos com peso"
              icon={<MdHowToVote fontSize="24px" color={colors.blue} />}
              title={"0"}
              loading={false}
            />
          </Col>
        </Row>
      </Box>
      <Box position={"relative"} h={"550px"}>
        {isLoadingAssembleia ? (
          <Skeleton rounded="16px" w="100%" h="100%" />
        ) : null}
        {!isLoadingAssembleia && data?.webinarId ? (
          <Flex
            flex={1}
            justifyContent="center"
            alignItems={"center"}
            rounded="16px"
            bg="gray.600"
            w="100%"
            h="100%"
          >
            <Button
              // isLoading={isLoading}
              gap="8px"
              as="a"
              target="_blank"
              href={data.webinarJoinUrl}
            >
              <MdPlayCircle /> Iniciar Video
            </Button>
          </Flex>
        ) : null}

        <MeetingContainer>
          <Box id="meetingSDKElement"></Box>
        </MeetingContainer>
      </Box>
    </>
  );
}

export default VideoConferencia;
